// PROJECT IMPORTS
import ConfirmationModal from "./ConfirmationModal";

// TYPES
interface DeleteProps {
  visible: boolean;
  isLoading?: boolean;
  onCancelClick?: any;
  onDoneClick?: any;
  title: string;
  content?: string;
}

/* ============================== DELETE MODEL ============================== */

const DeleteModal = (props: DeleteProps) => {
  const {
    visible = false,
    isLoading = false,
    onCancelClick,
    onDoneClick,
    title = "Are you sure you want to delete this?",
    content = "This action cannot be undone. Deleting the item will permanently remove all its content and cannot be recovered.",
  } = props;

  return (
    <>
      <ConfirmationModal
        isLoading={isLoading}
        open={visible}
        title={title}
        description={content}
        onCancel={onCancelClick}
        onConfirm={onDoneClick}
      />
    </>
  );
};

export default DeleteModal;
